import { UserService } from '../../../../services/user.service';
import { CommonConstant, GenderPerAgeChartYMaxRange, GenderEnum } from '../../../../app.constants';
var NewGenderPerAgeChartComponent = /** @class */ (function () {
    function NewGenderPerAgeChartComponent(userService) {
        this.userService = userService;
    }
    NewGenderPerAgeChartComponent.prototype.ngOnInit = function () {
        this.loadYAxisValue();
        this.yAxisMaxValue = Math.max.apply(Math, this.yAxis);
        this.barFullHeight = CommonConstant.GENDER_PER_AGE_CHART_FULL_HEIGHT;
    };
    NewGenderPerAgeChartComponent.prototype.loadYAxisValue = function () {
        if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_40) {
            this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_50;
        }
        else if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_65 && this.maxPercent > GenderPerAgeChartYMaxRange.MAX_40) {
            this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_75;
        }
        else if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_90 && this.maxPercent > GenderPerAgeChartYMaxRange.MAX_65) {
            this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_100;
        }
        else {
            this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_125;
        }
    };
    Object.defineProperty(NewGenderPerAgeChartComponent.prototype, "barMaleColor", {
        get: function () {
            return this.userService.chartColors[GenderEnum.MALE];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewGenderPerAgeChartComponent.prototype, "barFemaleColor", {
        get: function () {
            return this.userService.chartColors[GenderEnum.FEMALE];
        },
        enumerable: true,
        configurable: true
    });
    NewGenderPerAgeChartComponent.prototype.getBarHeight = function (value) {
        return value >= this.yAxisMaxValue ? CommonConstant.GENDER_PER_AGE_CHART_FULL_HEIGHT : (value / this.yAxisMaxValue) * 100;
    };
    NewGenderPerAgeChartComponent.prototype.formatRangeVaule = function (range) {
        var formatedRange;
        if (range.indexOf(CommonConstant.GENDER_PER_AGE_HIGHEST_RANGE_VALUE) >= 0) {
            formatedRange = CommonConstant.GENDER_PER_AGE_CHART_LAST_RANGE_VALUE;
        }
        else {
            formatedRange = range.replace('-', ' - ');
        }
        return formatedRange;
    };
    return NewGenderPerAgeChartComponent;
}());
export { NewGenderPerAgeChartComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/new-gender-per-age-chart/new-gender-per-age-chart.component.ts.pre-build-optimizer.js